import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "tree-container"
};
const _hoisted_2 = {
  class: "custom-tree-node"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["title"];
const _hoisted_5 = {
  class: "icons"
};
const _hoisted_6 = ["src", "onClick"];
const _hoisted_7 = ["src", "onClick"];
const _hoisted_8 = ["src", "onClick"];
const _hoisted_9 = {
  class: "add-item"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_aside, {
    width: "220px"
  }, {
    default: _withCtx(() => [_createElementVNode("p", {
      class: "search-item",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/assets-lib/search'))
    }, "素材搜索"), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tree, {
      data: $setup.data,
      class: "tree",
      props: $setup.defaultProps,
      onNodeClick: $setup.nodeClick
    }, {
      default: _withCtx(({
        node,
        data
      }) => [_createElementVNode("span", _hoisted_2, [_createElementVNode("img", {
        src: require('@/assets/icons/NavTree/file-icon.svg'),
        alt: "",
        class: "icon"
      }, null, 8, _hoisted_3), _createElementVNode("span", {
        title: node.label
      }, _toDisplayString(node.label), 9, _hoisted_4), _createElementVNode("span", _hoisted_5, [_createElementVNode("img", {
        src: require('@/assets/icons/add.svg'),
        alt: "",
        onClick: _withModifiers($event => $setup.operateHandler('add', data), ["stop"])
      }, null, 8, _hoisted_6), _createElementVNode("img", {
        src: require('@/assets/icons/edit.svg'),
        alt: "",
        onClick: _withModifiers($event => $setup.operateHandler('update', data), ["stop"])
      }, null, 8, _hoisted_7), _createElementVNode("img", {
        src: require('@/assets/icons/delete.svg'),
        alt: "",
        onClick: _withModifiers($event => $setup.delHandler(data), ["stop"])
      }, null, 8, _hoisted_8)])])]),
      _: 1
    }, 8, ["data", "props", "onNodeClick"]), _createElementVNode("p", _hoisted_9, [_createElementVNode("img", {
      src: require('@/assets/icons/add.svg'),
      alt: "",
      onClick: _cache[1] || (_cache[1] = _withModifiers($event => $setup.operateHandler('add', {}), ["stop"]))
    }, null, 8, _hoisted_10)])])]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    title: $setup.operation === 'add' ? '新建收藏夹' : '修改收藏夹',
    modelValue: $setup.show,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.show = $event),
    width: "300px",
    "custom-class": "fav-dialog"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_11, [_createVNode(_component_el_button, {
      onClick: _cache[3] || (_cache[3] = $event => $setup.show = false)
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.confirmHandler
    }, {
      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("确 定", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      size: "small",
      inline: true,
      model: $setup.form,
      class: "demo-form-inline"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "名称"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $setup.form.name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.form.name = $event),
          placeholder: "请输入收藏夹名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["title", "modelValue"])], 64);
}